import React from "react";
import {
    MainContainer,
    HeadSeo
} from "@beacharound/beacharound-ui";
import { getAddressString } from "@beacharound/beacharound-ui-helpers";
import { useQuery } from "react-query";
import { getHotel } from "../../api/hotels";
import { getBeach } from "../../api/beach";
import ReviewsPlaceList from "../../components/Reviews/ReviewsPlaceList";

export default function ReviewsListPage({match, history}) {

    const { hotelSlug, beachSlug } = match.params;

    let getActivityFunction, reviewedType, activitySlug;

    if (beachSlug) {
        reviewedType = "beaches";
        activitySlug = beachSlug;
        getActivityFunction = () => {
            return getBeach({ slug: beachSlug });
        };
    }

    if (hotelSlug) {
        reviewedType = "hotels";
        activitySlug = hotelSlug;
        getActivityFunction = () => {
            return getHotel({ slug: hotelSlug });
        };
    }

    const { data: activity } = useQuery(
        [reviewedType, activitySlug],
        getActivityFunction
    );

    return (
        <MainContainer>
            {activity &&
                <HeadSeo
                    title={[`Le recensioni su ${activity?.name} a ${activity?.address?.city}`]}
                    description={`Scopri le opinioni delle persone che hanno visitato ${activity?.name} prima di te. Scrivi la tua recensione e raccontaci la tua esperienza dopo aver visitato ${activity?.name}.`}
                    type={hotelSlug ? "Hotel" : "Beach"}
                    image={activity?.cover}
                    additions={{address: getAddressString(activity?.address)}}
                />
            }

            <ReviewsPlaceList
                place={activity?._id}
                title={`Tutte le recensioni su ${activity?.name}`}
                limit={20}
                infiteLoading
            ></ReviewsPlaceList>
        </MainContainer>
    );
}
